/*** IMPORTS FROM imports-loader ***/
var global = window;

const defaultLogger = console;

export { defaultLogger };
//# sourceMappingURL=logger.esm.js.map

